import React from 'react';
import { Box, Text } from '@mantine/core';
import { formatDateWithDay } from '@/helpers';
import { TodoBucketItem } from '../types';
import PaperSection from '../PaperSection';
import useTodoSection from './useTodoSection';
import TodoItem from './Todo.item';
import { EmptyList } from '../EmptyList';

const itemKey = (item: TodoBucketItem): string =>
  item.type === 'task' ? `task-${item.task.id}` : `availability-${item.summary.productType}`;

const TodoSection: React.FC = () => {
  const { loading, error, tasksByDate } = useTodoSection();

  return (
    <PaperSection loading={loading} title="TO DO’S" error={error} mt="xl">
      {tasksByDate.length > 0 ? (
        tasksByDate.map(({ items, date }) => (
          <React.Fragment key={date}>
            <Box bg="blue.1" px="sm">
              <Text size="sm">{formatDateWithDay(date)}</Text>
            </Box>
            {items.map((item) => (
              <TodoItem key={itemKey(item)} item={item} />
            ))}
          </React.Fragment>
        ))
      ) : (
        <EmptyList text="You've done all there is to do!" />
      )}
    </PaperSection>
  );
};

export default TodoSection;
